import { FileReference } from '@kaizenplatform/belfast-entity';
import { FileIdsValue, SelectMultipleValue } from '@kaizenplatform/hugot-entity';

import {
  DynamicSchemaDefinitionFieldType,
  DynamicSchemaDefinitionFiles,
  DynamicSchemaDefinitionFixed,
  DynamicSchemaDefinitionMultiLineText,
  DynamicSchemaDefinitionPositiveInteger,
  DynamicSchemaDefinitionSelectMultiple,
  DynamicSchemaDefinitionSelectOne,
  DynamicSchemaDefinitionSingleLineText,
  DynamicSchemaDefinitionToggle,
} from '../graphql/generated/graphql';

const isIncompleteCreativeBriefField = (
  field:
    | Pick<DynamicSchemaDefinitionFiles, 'type'>
    | Pick<DynamicSchemaDefinitionFixed, 'type'>
    | Pick<DynamicSchemaDefinitionMultiLineText, 'type'>
    | Pick<DynamicSchemaDefinitionPositiveInteger, 'type'>
    | Pick<DynamicSchemaDefinitionSelectMultiple, 'type'>
    | Pick<DynamicSchemaDefinitionSelectOne, 'type'>
    | Pick<DynamicSchemaDefinitionSingleLineText, 'type'>
    | Pick<DynamicSchemaDefinitionToggle, 'type'>,
  value: string | number | boolean | SelectMultipleValue | FileIdsValue | null,
  files: FileReference[] = [],
): boolean => {
  switch (field.type) {
    case DynamicSchemaDefinitionFieldType.SingleLineText:
    case DynamicSchemaDefinitionFieldType.MultiLineText:
      // Text
      return ((value as any) as string).trim().length === 0;
    case DynamicSchemaDefinitionFieldType.SelectMultiple:
      // Empty array
      return ((value as any) as Set<string>).size === 0;
    case DynamicSchemaDefinitionFieldType.Files:
      // Empty array
      return files.length === 0;
    case DynamicSchemaDefinitionFieldType.PositiveInteger:
      return value == null || (typeof value === 'string' && value.trim().length === 0);
    case DynamicSchemaDefinitionFieldType.SelectOne:
    case DynamicSchemaDefinitionFieldType.Toggle:
    case DynamicSchemaDefinitionFieldType.Fixed:
      // Always false
      return false;
    case DynamicSchemaDefinitionFieldType.FileIds:
      // CreativeBriefにFILE_IDSは存在しないのでどちらを返しても問題ない
      return true;
  }
};

export default isIncompleteCreativeBriefField;
